import artifactLock from "../../vendor/artist-domain/artifact-lock.json";
import artifactProvenance from "../../vendor/artist-domain/provenance-0.8.0-kmp.3-direct.1.json";

/**
 * Immutable descriptor for the vendored direct.3 Kotlin/JS artifact. The Web
 * contract mirror may advance independently; that must never relabel or widen
 * this historical 0.8 artifact.
 */
export const KMP_ARTIFACT_PACKAGE_NAME =
	artifactLock.packageName as "@xy-devmode/artist-domain";
export const KMP_ARTIFACT_API_VERSION =
	artifactLock.artifactApiVersion as "1.5.0";
export const KMP_ARTIFACT_CONTRACT_VERSION = artifactProvenance.contract
	.version as "0.8.0";
export const KMP_ARTIFACT_CONTRACT_DIGEST = artifactProvenance.contract
	.digest as `sha256:${string}`;
export const KMP_ARTIFACT_RUNNER_PROTOCOL_VERSION = "1.0.0" as const;
export const KMP_ARTIFACT_IMPLEMENTED_OPERATION_COUNT = 11 as const;
